/**
 * @summary Contains the Menu List preact component.
 */

import { h, Component } from 'preact';
import MenuItem from './MenuItem';

/**
 * @summary Menu List preact component.
 *
 * @export
 * @class
 * @extends {Component}
 */
export default class Menu extends Component {

	/**
	 * @summary Returns classes attribute value for a menu list.
	 *
	 * @param {('normal'|'drawer')} type  The type of menu.
	 * @param {Number} depth The depth of the menu.
	 * @returns {String} The class attribute value.
	 */
	menuClasses( type, depth ) {
		return this[`${type}MenuClasses`]( depth );
	}

	/**
	 * @summary Returns classes attribute value for a normal menu list.
	 *
	 * @param {Number} depth The depth of the menu.
	 * @returns {String} The class attribute value.
	 */
	normalMenuClasses( depth ) {
		if ( depth === 0 ) {
			return 'c-primary-menu__top-menu';
		}

		return `c-primary-menu__sub-menu ${depth > 1 ? ' c-primary-menu__sub-menu--deep' : ''}`;
	}

	/**
	 * @summary Returns classes attribute value for a drawer menu list.
	 *
	 * @param {Number} depth The depth of the menu.
	 * @returns {String} The class attribute value.
	 */
	drawerMenuClasses( depth ) {
		const baseName = 'c-drawer-menu__menu';
		return `${baseName} ${baseName}--${depth === 0 ? 'top' : 'sub'}`;
	}

	render({ menuTree, type = 'normal', depth = 0, style }) {
		const items = menuTree.map( ( item, i ) => (
			<MenuItem
				{...item}
				key={`${depth}:${i}`}
				depth={depth}
				type={type}
			/>
		) );

		return <ul class={this.menuClasses( type, depth )} style={style}>{items}</ul>;
	}
}



// WEBPACK FOOTER //
// ./src/js/components/Menu.js